/**
 * @module Location fav apis 
 *  Apis must need auth details to trigger url - NormalApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApi from '@/Components/Controllers/NormalApis';

export default {
  
    favLocationsListByLocationIds(location_ids) {
      let businessProfile = store.getters['businessprofile/detail'];
      let businessId =  businessProfile.id;
        const url = `${Env.locationUrl}/clients/businesses/${businessId}/locations?operation_hours=true&address=true&contact_details=true&images=true&page=1&limit=400`;
        return NormalApi.postApi(url, {
          "api-token": Env.apiToken,
        },{
          location_ids
        })
        .then(res => {
          store.dispatch('favouritestores/setList', res.data.payload)
          return res;
        })
        .catch(err => {
          store.dispatch('favouritestores/setList', [])
          return err;
        });
    },

}